import React, { useState } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import request from 'superagent';

const DealBuilderButton = ({
  additionalClasses,
  buttonLabel,
  stockReference,
}) => {
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);

  const openDealStacker = () => {
    setLoading(true);
    request
      .get(`/api/deal-stacker/${stockReference}`)
      .timeout({
        response: 60000, // Wait 60 seconds for the server to start sending - client first request to DS is slow...
        deadline: 60000, // but allow 1 minute for the file to finish loading.
      })
      .then((response) => {
        if (response.ok) {
          window.location.href = response.body.redirect_url;
          setLoading(false);
        }
      })
      .catch((err) => {
        setErrorMessage(true);
        setLoading(false);
        if (window.newrelic) {
          window.newrelic.noticeError(err);
        }
      });
  };

  return (
    <>
      <button
        className={classNames(
          `ch-btn ch-btn--primary ch-width--12 ch-ml--auto ${additionalClasses}`,
          {
            'ch-btn--loading': loading,
          }
        )}
        data-event-name="Product page: Opens deal builder"
        data-gtm-track="click_cta"
        data-gtm-track-label="Opened deal stacker"
        data-insight-event="conversion"
        onClick={openDealStacker}
        type="button"
      >
        {buttonLabel ? buttonLabel : 'Build your deal'}
      </button>

      {errorMessage && (
        <p className="ch-width--12 ch-mb--0 ch-mt--2 ch-bg--white ch-color--ac-red ch-fw--500">
          Something went wrong, please try again later
        </p>
      )}
    </>
  );
};

DealBuilderButton.displayName = 'DealBuilderButton';
DealBuilderButton.propTypes = {
  additionalClasses: PropTypes.string,
  buttonLabel: PropTypes.string,
  stockReference: PropTypes.string,
};

export default DealBuilderButton;
